/* LDS özel etkileşimleri → GTM veri katmanı (ldsDataLayer). TASLAK — yalnız yayınlanmamış temada.
   Yalnız etkileşim türü ve konumu gönderilir. İsim, isimlik metni, e-posta, telefon, mesaj veya adres GÖNDERİLMEZ.
   Standart e-ticaret olayları burada YOKTUR (Google & YouTube uygulamasındadır). */
(function () {
  'use strict';
  var L = 'ldsDataLayer';
  function push(event, data) {
    var o = { event: event }; if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) o[k] = data[k]; } }
    (window[L] = window[L] || []).push(o);
  }
  function where(el) {
    if (el.closest('[data-cart-root]')) return 'cart';
    if (el.closest('header')) return 'header';
    if (el.closest('footer')) return 'footer';
    return 'content';
  }

  // 1) personalization_open — sepette isimlik düzenleyicisinin AÇILMASI (kapanış sayılmaz)
  document.addEventListener('click', function (e) {
    var tg = e.target.closest && e.target.closest('[data-cart-root] [data-np-toggle]');
    if (tg && tg.getAttribute('aria-expanded') !== 'true') {
      push('lds_personalization_open', { lds_location: document.body.classList.contains('template-cart') ? 'cart_page' : 'cart_drawer' });
    }
  }, true);
  // … ve ürün sayfasında isimlik metin alanına İLK odak (sayfa görüntülemesi başına bir kez)
  var started = false;
  document.addEventListener('focusin', function (e) {
    if (started || !e.target.closest) return;
    if (!e.target.closest('[data-persona]') || !e.target.matches('input[type="text"], textarea')) return;
    started = true; push('lds_personalization_open', { lds_location: 'product_page' });
  });

  // 2) support_click — iletişim sayfası, e-posta veya telefon bağlantısı (adres/numara gönderilmez)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href') || ''; var type = null;
    if (/^mailto:/i.test(h)) type = 'email';
    else if (/^tel:/i.test(h)) type = 'phone';
    else if (/\/pages\/contact(?:[\/?#]|$)/.test(h)) type = 'contact_page';
    if (!type) return;
    push('lds_support_click', { lds_link_type: type, lds_location: where(a) });
  }, true);

  // 3) inquiry_submit_success — iletişim formunun sunucu tarafından onaylanan başarılı gönderimi (düğme tıklaması değil).
  //    Sayfa yenilenince yeniden sayılmasın diye adresteki contact_posted parametresi kaldırılır.
  function inquiry() {
    if (!document.querySelector('#ContactForm .form-message[role="status"]')) return;
    push('lds_inquiry_submit_success', {});
    try {
      var u = new URL(location.href);
      if (u.searchParams.has('contact_posted')) { u.searchParams.delete('contact_posted'); history.replaceState(null, '', u.pathname + u.search + u.hash); }
    } catch (x) { /* eski tarayıcı */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inquiry); else inquiry();
})();
